/**
 * Teams deep links (AB#6195 follow-up): a plain https://app.montblanc.ai/...
 * URL pasted into a Teams chat opens in a browser, not back inside the
 * Teams tab -- useless for someone who never opens a browser at all. A
 * Teams deep link (https://teams.microsoft.com/l/entity/...) tells Teams
 * itself to reopen the app's own tab, at whichever in-app path is encoded
 * in `context.subEntityId`. TeamsApp.tsx reads that back out via
 * app.getContext().page.subPageId on load.
 */

// The static tab's own entityId, from teams-manifest/manifest.json's
// staticTabs[0] -- there is only one tab, so this never varies by
// environment (unlike the app id below, which does).
const ENTITY_ID = 'montblancai-home'

// Per-environment app id, matching teams-manifest/environments.json's
// dev.id / prod.id -- injected at build time (see the two
// azure-pipelines-*-static-webapp.yml files) since the frontend has no
// other way to know its own Teams manifest id.
const getTeamsAppId = (): string | undefined => import.meta.env.VITE_TEAMS_APP_ID

// The in-app path to encode, or the current one if none is given.
export const buildTeamsDeepLink = (path?: string): string | null => {
  const teamsAppId = getTeamsAppId()
  if (!teamsAppId) {
    return null
  }

  const subEntityId = path ?? window.location.pathname + window.location.search
  const context = encodeURIComponent(JSON.stringify({subEntityId}))
  const webUrl = encodeURIComponent(new URL(subEntityId, window.location.origin).toString())

  return `https://teams.microsoft.com/l/entity/${teamsAppId}/${ENTITY_ID}?context=${context}&webUrl=${webUrl}`
}
